module.exports = __webpack_public_path__ + "media/images/february23/february23-template-ru-336d5b899867a6332806cbd9caf6f120.png";